import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { mainHeading, subHeading } from "../../styles/style";
import OurClientsCard from "../../assets/cards/OurClientsCard";
import { ArrowForwardIos } from "@mui/icons-material";

export default function OurClients() {
  return (
    <>
      <Box className="pplacd-container">
        <Grid container spacing={2}>
          <Grid item md={12}>
            <Typography sx={subHeading}>Experience With PPLACD</Typography>
            <Typography sx={mainHeading}>A word From Our Clients</Typography>

            <div
              id="carouselExampleDark"
              className="carousel carousel-dark slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carouselExampleDark"
                  data-bs-slide-to="0"
                  className="active"
                  aria-current="true"
                  aria-label="Slide 1"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carouselExampleDark"
                  data-bs-slide-to="1"
                  aria-label="Slide 2"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carouselExampleDark"
                  data-bs-slide-to="2"
                  aria-label="Slide 3"
                ></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active" data-bs-interval="10000">
                  <Grid container spacing={2} mb={10}>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                  </Grid>
                </div>
                <div className="carousel-item" data-bs-interval="2000">
                  <Grid container spacing={2} mb={10}>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                  </Grid>
                </div>
                <div className="carousel-item">
                  <Grid container spacing={2} mb={10}>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                    <Grid item md={3}>
                      <OurClientsCard />
                    </Grid>
                  </Grid>
                </div>
           
              </div>
              {/* <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button> */}
            </div>

            <Box className="flexbgbtn">
              <button className="bgbtn" type="button">
                View More <ArrowForwardIos sx={{ fontSize: "16px" }} />{" "}
              </button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
